<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader :user_id='user_id'></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom:30px;">
			<div style="width:1200px;margin:auto;padding:20px;height:1040px;">
				<rosidebar></rosidebar>
				<div style="float: right;width:calc(100% - 269px);overflow: hidden;">
					<div style="width: 100%;background-color: white;height:1090px;padding: 20px;border-radius: 5px;">
						<el-tabs v-model="activeName" type="card">
							<el-tab-pane label="待办事项" name="to_do_list">
								<div style="width: 100%;">
									<el-table :data="to_do_list" style="width: 100%;" height="1000" stripe>

										<el-table-column prop="name" label="事项名称" width="170">
										</el-table-column>
										<el-table-column prop="name" label="创建时间" width="150">
										</el-table-column>
										<el-table-column prop="name" label="订单名称" width="170">
										</el-table-column>
										<el-table-column prop="name" label="订单状态" width="100">
										</el-table-column>
										<el-table-column fixed="right" label="操作" width="150">
											<template slot-scope="scope">
												<el-button @click="handleClick(scope.row)" type="text" size="small">操作1
												</el-button>
												<el-button type="text" size="small">操作2</el-button>
												<el-button type="text" size="small">操作3</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
							</el-tab-pane>
		<!-- 					<el-tab-pane label="未完成订单" name="outstanding_orders">
								<div style="width: 100%;">
									<el-table :data="outstanding_orders" style="width: 100%;" height="1000" stripe>
										<el-table-column prop="name" label="事项名称" width="170">
										</el-table-column>
										<el-table-column prop="name" label="创建时间" width="150">
										</el-table-column>
										<el-table-column prop="name" label="订单名称" width="170">
										</el-table-column>
										<el-table-column prop="name" label="订单状态" width="100">
										</el-table-column>
										<el-table-column fixed="right" label="操作" width="150">
											<template slot-scope="scope">
												<el-button @click="handleClick(scope.row)" type="text" size="small">操作1
												</el-button>
												<el-button type="text" size="small">操作2</el-button>
												<el-button type="text" size="small">操作3</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
							</el-tab-pane>
						 -->
						</el-tabs>
					</div>
				</div>
			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'user_index',
		data() {
			return {
				customer_options: [],
				product_options: [],
				customer_id: [],
				product_ids: [],
				tableData: [],
				tabClickIndex: null,
				tabClickLabel: null,
				activeName: 'to_do_list',

				to_do_list: [
				],
				outstanding_orders: [],
				user_id:'11'

			}
		},
		mounted() {
			var self = this
			fetchPost('/ro/report_data_center/fcst/datas/sale').then(function(data) {
		

			})

			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {

			tabClick(row, column, cell, event) {
				switch (column.label) {
					case '顺序':
						this.tabClickIndex = row.index
						this.tabClickLabel = column.label
						break
					default:
						return
				}
				console.log('tabClick', this.tabClickIndex, row.adName, row.adSort)
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				// 把每一行的索引放进row
				row.index = rowIndex
			},
			check_data() {
				var self = this;
				// 产品数据
				// var product_ids = this.product_ids
				// 客户
				var customer_id = this.customer_id
				// 查询数据
				// debugger;
				var postdata = {
					// 'product_ids': product_ids.join(','),
					'customer_id': customer_id,
				}
				// debugger;
				fetchPost('/ro/report_data_center/cost/datas/check', postdata, ).then(function(data) {

					self.tableData = data.data['product_data']

				})


			}
		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}
	.el-table th{
		text-align: center !important;
		background-color: #F0F0F0;
		color:#333;
	}
	.el-table td{
		text-align: center !important;	
	}
</style>
